import {
  useEffect
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import PaymentDetails from "../components/PaymentDetails";

import {
  usePayments
} from "../hooks/usePayments";

const PaymentDetailsPage = () => {
  const {
    id
  } = useParams();

  const navigate =
    useNavigate();

  const {
    selectedPayment,
    fetchPayment,
    selectedPaymentLoading,
    selectedPaymentError
  } = usePayments();


  useEffect(() => {
    if (id) {
      fetchPayment(id);
    }
  }, [
    id,
    fetchPayment
  ]);


  return (
    <div className="payment-details-page">
      <div className="payment-details-page__header">
        <button
          type="button"
          onClick={() =>
            navigate(
              "/payments"
            )
          }
        >
          Back to Payments
        </button>
      </div>

      {selectedPaymentLoading && (
        <div className="payment-details-page__loading">
          Loading payment...
        </div>
      )}

      {selectedPaymentError && (
        <div className="payment-details-page__error">
          Failed to load payment.
        </div>
      )}

      {!selectedPaymentLoading &&
        selectedPayment && (
          <PaymentDetails
            payment={
              selectedPayment
            }
          />
        )}
    </div>
  );
};

export default PaymentDetailsPage;
